// Pages
import PushPage from './PushPage';

// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Axios
import axios from 'axios';

// AntD Mobile
import { Picker } from 'antd-mobile'

// VK
import { Group, Button, Gallery, Text } from '@vkontakte/vkui';
import baseTheme from '@vkontakte/vkui-tokens/themes/vkBase';

// Telegram UI
import { AppRoot, Accordion, Chip, Blockquote, ButtonCell, Cell, Section, IconButton, Modal, List, Input, Image, Spinner, Select, Skeleton } from '@telegram-apps/telegram-ui';

// Confetti
import ConfettiExplosion from 'react-confetti-explosion';

// Lottie
import Lottie from 'react-lottie';
import nameLottie from '../lotties/name.json';
import sourcesLottie from '../lotties/sources.json';
import keywordsLottie from '../lotties/keywords.json';
import stopLottie from '../lotties/stop.json';
import intervalLottie from '../lotties/interval.json';
import finishLottie from '../lotties/finish.json';

// Antd Mobile
import { Swiper } from 'antd-mobile'
import { SwiperRef } from 'antd-mobile/es/components/swiper'

import Logo from '../Logo';

import gmp from '../lotties/gmp.json';
import gmpSave from '../lotties/save.json';

// Icons
import { ReactComponent as AddIcon } from "../assets/add.svg";
import { ReactComponent as PostsIcon } from "../assets/posts.svg";
import { ReactComponent as PostingIcon } from "../assets/posting.svg";
import { ReactComponent as ModeIcon } from "../assets/mode.svg";
import { ReactComponent as StreamsIcon } from "../assets/streams.svg";
import { ReactComponent as StreamsOutlineIcon } from "../assets/streams_outline.svg";
import { ReactComponent as HelpIcon } from "../assets/help.svg";
import { ReactComponent as PlanIcon } from "../assets/plan.svg";
import { ReactComponent as FilterIcon } from "../assets/filter.svg";
import { ReactComponent as SourcesIcon } from "../assets/sources.svg";
import { ReactComponent as StyleIcon } from "../assets/style.svg";
import { ReactComponent as TimersIcon } from "../assets/timers.svg";
import { ReactComponent as OtherIcon } from "../assets/other.svg";
import { ReactComponent as RightArrow } from "../assets/right_arrow.svg";

import { ReactComponent as DeleteIcon } from "../assets/delete.svg";
import { ReactComponent as CancelIcon } from "../assets/cancel.svg";
import { ReactComponent as TelegramNotice } from '../assets/social/tg_notice.svg';

const tg = window.Telegram.WebApp;

const ChannelPageTest = ({ activePanel, setActivePanel, avatarSrc, selectedGroup, setSelectedGroup, premodePosts, setChannels, setGroups, setPremodePosts, selectedStreamIndex, setSelectedStreamIndex, stream, setStream }) => {
    const totalSlides = 3;  // Общее количество слайдов
    const [slideIndex, setSlideIndex] = useState(0);
    const [buttonName, setButtonName] = useState("Далее");
    const [secondButtonText, setSecondButtonText] = useState("Без ключевых слов");
    const [secondButton, setSecondButton] = useState(false);
    const ref = useRef(null);
    const [name, setName] = useState('');
    const [sources, setSources] = useState([]);
    const [timers, setTimers] = useState(['12:00', '15:00', '20:00']);
    const [timezone, setTimezone] = useState(0);
    const [timezoneTimers, setTimeZoneTimers] = useState(['12:00', '15:00', '20:00']);
    const [keywords, setKeywords] = useState([]);
    const [negative, setNegative] = useState([]);
    const [interval, setInterval] = useState(10);
    const [isAdding, setIsAdding] = useState(false);
    const [sourceRef, setSourceRef] = useState(null);
    const [addLoading, setAddLoading] = useState(false);
    const [isInputDisabled, setIsInputDisabled] = useState(false);
    const [disableNext, setDisableNext] = useState(true);

    const [nameFade, setNameFade] = useState(false);
    const [sourcesFade, setSourcesFade] = useState(false);
    const [keywordsFade, setKeywordsFade] = useState(true);
    const [negativeFade, setNegativeFade] = useState(true);
    const [intervalFade, setIntervalFade] = useState(true);

    const [timeVisible, setTimeVisible] = useState(false);

    const [keywordRef, setKeywordRef] = useState(null);
    const [negativeRef, setNegativeRef] = useState(null);

    const [mainButtonAction, setMainButtonAction] = useState(1);
    const [secondButtonAction, setSecondButtonAction] = useState(1);

    const [formattedSources, setFormattedSources] = useState([]);

    const [feedId, setFeedId] = useState('');

    const skeleton_favicon = "https://gmpapp.ru/images/no_favicon.svg"

    const nameOpt = { loop: true, autoplay: true, animationData: nameLottie, rendererSettings: { preserveAspectRatio: "xMidYMid slice" } };
    const sourcesOpt = { loop: true, autoplay: true, animationData: sourcesLottie, rendererSettings: { preserveAspectRatio: "xMidYMid slice" } };
    const keywordsOpt = { loop: true, autoplay: true, animationData: keywordsLottie, rendererSettings: { preserveAspectRatio: "xMidYMid slice" } };
    const stopOpt = { loop: true, autoplay: true, animationData: stopLottie, rendererSettings: { preserveAspectRatio: "xMidYMid slice" } };
    const intervalOpt = { loop: true, autoplay: true, animationData: intervalLottie, rendererSettings: { preserveAspectRatio: "xMidYMid slice" } };
    const finishOpt = { loop: true, autoplay: true, animationData: finishLottie, rendererSettings: { preserveAspectRatio: "xMidYMid slice" } };

    useEffect(() => {
        const adjustTimeWithShift = (timers, timezone) => {
            return timers.map(timeString => {
                const [hours, minutes] = timeString.split(':').map(Number);
                const newHours = (hours + timezone + 24) % 24; // Добавляем 24 и используем модуль, чтобы избежать отрицательных значений
                return `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
            });
        };

        const updateAdjustedTags = adjustTimeWithShift(timers, timezone);
        setTimeZoneTimers(updateAdjustedTags);
    }, [timers, timezone])

    useEffect(() => {
        // Проверяем длину timezoneTimers
        if (timezoneTimers.length < 1) {
            // Скрываем hr элементы добавлением класса к корневому элементу
            document.body.classList.add('hide-hr');
        } else {
            // Удаляем класс, если таймеры есть
            document.body.classList.remove('hide-hr');
        }
    }, [timezoneTimers]); // Зависимость от timezoneTimers

    const formatTime = (date) => {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const handleZoneChange = (event) => {
        const intValue = parseInt(event.target.value, 10);
        setTimezone(intValue)
    };

    const handleDeleteTimer = (timer) => {
        const [hours, minutes] = timer.split(':').map(Number);
        const newHours = (hours - timezone + 24) % 24;

        const timerToDelete = `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
        const updatedTimers = timers.filter(timer => timer !== timerToDelete);

        setTimers(updatedTimers);
    }

    const generateTimeOptions = (start, end, suffix = '') => {
        const options = [];
        for (let i = start; i <= end; i++) {
            const label = i.toString().padStart(2, '0');
            options.push({ label, value: label + suffix });
        }
        return options;
    };

    const basicColumns = [
        generateTimeOptions(0, 23),
        [':'],
        generateTimeOptions(0, 59),
    ];

    const timeZones = [
        { gmt: "GMT-12 (Бейкер)", shift: -15 },
        { gmt: "GMT-11 (Паго-Паго)", shift: -14 },
        { gmt: "GMT-10 (Гонолулу)", shift: -13 },
        { gmt: "GMT-9 (Анкоридж)", shift: -12 },
        { gmt: "GMT-8 (Лос-Анджелес)", shift: -11 },
        { gmt: "GMT-7 (Денвер)", shift: -10 },
        { gmt: "GMT-6 (Чикаго, Мехико)", shift: -9 },
        { gmt: "GMT-5 (Нью-Йорк, Богота)", shift: -8 },
        { gmt: "GMT-4 (Сантьяго, Каракас)", shift: -7 },
        { gmt: "GMT-3 (Буэнос-Айрес, Бразилиа)", shift: -6 },
        { gmt: "GMT-2 (Среднеатлантическое время)", shift: -5 },
        { gmt: "GMT-1 (Азорские острова)", shift: -4 },
        { gmt: "GMT±0 (Лондон, Дакар)", shift: -3 },
        { gmt: "GMT+1 (Париж, Берлин, Лагос)", shift: -2 },
        { gmt: "GMT+2 (Калининград, Афины, Каир)", shift: -1 },
        { gmt: "GMT+3 (Москва, Санкт-Петербург, Казань)", shift: 0 },
        { gmt: "GMT+4 (Самара, Волгоград, Дубай, Баку)", shift: 1 },
        { gmt: "GMT+5 (Екатеринбург, Уфа, Ташкент)", shift: 2 },
        { gmt: "GMT+6 (Омск, Челябинск, Алматы)", shift: 3 },
        { gmt: "GMT+7 (Новосибирск, Красноярск, Бангкок)", shift: 4 },
        { gmt: "GMT+8 (Иркутск, Улан-Удэ, Пекин)", shift: 5 },
        { gmt: "GMT+9 (Якутск, Чита, Токио, Сеул)", shift: 6 },
        { gmt: "GMT+10 (Владивосток, Хабаровск, Сидней)", shift: 7 },
        { gmt: "GMT+11 (Магадан, Сахалин)", shift: 8 },
        { gmt: "GMT+12 (Камчатка, Анадырь, Окленд)", shift: 9 },
        { gmt: "GMT+13 (Тонга, Апиа)", shift: 10 },
        { gmt: "GMT+14 (Лайн-Айлендс)", shift: 11 }
    ];

    const isTelegramLink = (name) => {
        // Проверяем, начинается ли строка с одного из указанных префиксов
        return (
            name.startsWith('https://t.me/') ||
            name.startsWith('http://t.me/') ||
            name.startsWith('t.me/') ||
            name.startsWith('@')
        );
    };

    const [accordionStates, setAccordionStates] = useState(
        formattedSources.map(() => false) // Изначально все аккордеоны закрыты
    );

    const handleAccordionChange = (index) => {
        setAccordionStates((prevStates) => {
            const newStates = [...prevStates];
            newStates[index] = !newStates[index]; // Инвертируем состояние
            return newStates;
        });
    };

    const handleAddKeyword = () => {
        if (keywordRef && !keywords.includes(keywordRef)) {
            setKeywords((prevKeywords) => [...prevKeywords, keywordRef]);
        }
        setKeywordRef('');
    };

    const handleAddNegative = () => {
        if (negativeRef && !negative.includes(negativeRef)) {
            setNegative((prevNegative) => [...prevNegative, negativeRef]);
        }
        setNegativeRef('');
    };

    const handleKeywordsPress = (e) => {
        // Если нажата клавиша Enter или введен знак запятой
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault(); // Остановка стандартного поведения (например, добавление новой строки)
            handleAddKeyword(); // Вызов функции handleAddKeyword
            setKeywordRef('');
        }
    };

    const handleNegativePress = (e) => {
        // Если нажата клавиша Enter или введен знак запятой
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault(); // Остановка стандартного поведения (например, добавление новой строки)
            handleAddNegative(); // Вызов функции handleAddKeyword
            setNegativeRef('');
        }
    };

    const handleSourcePress = (e) => {
        // Если нажата клавиша Enter или введен знак запятой
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault(); // Остановка стандартного поведения (например, добавление новой строки)
            addSource(); // Вызов функции addSource
        }
    };

    const handleSaveFeed = async () => {
        const data = {
            group_id: selectedGroup.id,  // Пример ID пользователя
            sources: sources,  // Источники
            keywords: keywords,  // Ключевые слова
            negative: negative,  // Негативные слова
            timers: timers, // Таймеры
            shift: timezone // Часовой пояс
        };

        try {
            const response = await axios.post('https://api.gmpapp.ru/save_channel_onboarding', data);

            console.log('Channel created successfully:', response.data);

            ref.current?.swipeNext();

        } catch (error) {
            if (error.response) {
                // Сервер ответил с кодом состояния, который выходит за пределы 2xx
                console.error('Error creating feed:', error.response.data);
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                console.error('No response received:', error.request);
                console.log(data)
            } else {
                // Что-то случилось при настройке запроса
                console.error('Error setting up request:', error.message);
            }
        }
    };

    const handleSaveActive = async () => {
        const data = {
            group_id: selectedGroup.id
        };

        try {
            const response = await axios.post('https://api.gmpapp.ru/save_active_onboarding', data);

            console.log('Channel created successfully:', response.data);

            setActivePanel('home');

        } catch (error) {
            if (error.response) {
                // Сервер ответил с кодом состояния, который выходит за пределы 2xx
                console.error('Error creating feed:', error.response.data);
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                console.error('No response received:', error.request);
                console.log(data)
            } else {
                // Что-то случилось при настройке запроса
                console.error('Error setting up request:', error.message);
            }
        }
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('home');
        };

        if (activePanel === 'onboarding') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        if (slideIndex === 0) {
            if (sources.length > 0) {
                setDisableNext(false);
            } else {
                setDisableNext(true);
            }
        } else if (slideIndex === 1) {
            setKeywordsFade(false);
            setSourcesFade(true);
            setSecondButton(true);
            if (keywords.length > 0) {
                setDisableNext(false);
            } else {
                setDisableNext(true);
            }
        } else if (slideIndex === 2) {
            setNegativeFade(false);
            setKeywordsFade(true);
            setSecondButtonText('Без стоп-слов')
            if (negative.length > 0) {
                setDisableNext(false);
            } else {
                setDisableNext(true);
            }
        } else if (slideIndex === 3) {
            setIntervalFade(false);
            setNegativeFade(true);
            setSecondButton(false);
            setMainButtonAction(2);
            setButtonName('Сохранить')
            setDisableNext(false);
        } else if (slideIndex === 4) {
            setButtonName('Активировать сейчас')
            setSecondButtonText('Активировать позже')
            setMainButtonAction(3);
            setSecondButtonAction(2);
            setSecondButton(true);

            setNameFade(true);
            setSourcesFade(true);
            setNegativeFade(true);
            setKeywordsFade(true);
            setIntervalFade(true);

            setDisableNext(false);
        } else {
            // Дефолтное поведение или другие слайды
            setDisableNext(true);
        }
    }, [name, sources, keywords, negative, interval, slideIndex]);

    const addSource = async () => {
        setIsAdding(true);
        setAddLoading(true);
        setIsInputDisabled(true);
        setSources([...sources, sourceRef]); // Добавляем новый источник в список
        try {
            const response = await fetch(`https://api.gmpapp.ru/get_title?url=${sourceRef}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            console.log(`${data.title}\n${data.favicon}\n${data.desc}`);
            setFormattedSources((prevSources) => [
                ...prevSources,
                {
                    title: data.title,
                    name: sourceRef,
                    favicon: data.favicon,
                    desc: data.desc
                }
            ]);
        } catch (error) {
            console.error('Error fetching data:', error); // Покажем полное сообщение об ошибке
        }
        finally {
            setAddLoading(false);
            setIsAdding(false);
            setSourceRef('');
            setIsInputDisabled(false);
        }
    };

    const handleMainButton = () => {
        if (mainButtonAction === 1) {
            ref.current?.swipeNext();
        } else if (mainButtonAction === 2) {
            handleSaveFeed();
        } else if (mainButtonAction === 3) {
            handleSaveActive();
        } else {
            setActivePanel('home');
        }
    };

    const handleSecondButton = () => {
        if (secondButtonAction === 1) {
            ref.current?.swipeNext();
        } else {
            setActivePanel('home');
        }
    };

    return (
        <div className="onboardingContainter">
            <div className="onboarding" style={{ display: "flex" }}>
                <Swiper autoHeight={true} ref={ref} allowTouchMove={false} onIndexChange={i => { setSlideIndex(i); }} indicator={() => null}>
                    <Swiper.Item className={(sourcesFade ? 'fadeSlide' : null)}>
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={sourcesOpt}
                            height={150}
                            width={150}
                        />
                        <div className="welcome_no">
                            <Text className="welcomeHeadline" normalize={true} weight="1">Источники</Text>
                        </div>
                        <Text style={{ textAlign: "center" }} className="welcomeDesc" normalize={true} weight="3">Откуда сервис будет брать новости для вашего канала</Text>
                        <AppRoot platform='ios'>
                            <Section className='sectionChannelSources sectionSourceDone' footer="Здесь вы можете добавить источники, откуда сервис будет брать новости или посты. Источником может быть любой новостной сайт, Telegram-канал или группа/паблик VK">
                                {formattedSources.map((source, index) => (
                                    <Cell
                                        before={
                                            <Image className='sourceFavicon' size={28} src={source.favicon}>
                                                {isTelegramLink(source.name) && <TelegramNotice className='socialBadge' />}
                                            </Image>
                                        }
                                        subtitle={source.name}
                                        key={index}
                                        after={
                                            <CancelIcon
                                                onClick={() => {
                                                    const sourceNameToRemove = source.name;

                                                    // Убираем элемент из обоих массивов
                                                    setSources((prevSources) =>
                                                        prevSources.filter((item) => item !== sourceNameToRemove)
                                                    );

                                                    // Убираем элемент из formattedSources
                                                    setFormattedSources((prevFormattedSources) =>
                                                        prevFormattedSources.filter((item) => item.name !== sourceNameToRemove)
                                                    );
                                                }}
                                            />
                                        }
                                    >
                                        {source.title}
                                    </Cell>
                                ))}
                                {isAdding ?
                                    <Cell before={<Skeleton visible><Image style={{ borderRadius: "20px" }} className='sourceFavicon' size={28} src={skeleton_favicon}></Image></Skeleton>} subtitle={<Skeleton visible>Skeleton</Skeleton>}>
                                        <Skeleton visible>Skeleton title lorem ipsum</Skeleton>
                                    </Cell> : null}
                                {/* <Input after={<IconButton disabled={!sourceRef} onClick={addSource} className="addSource" size="m">{addLoading ? <Spinner size="s" /> : <AddIcon />}</IconButton>} value={sourceRef} onKeyPress={handleSourcePress} disabled={isInputDisabled} onChange={e => setSourceRef(e.target.value)} status="focused" header="Input" placeholder="Введите источник..." /> */}
                                <Input after={<Button className="addSource" before={<AddIcon />} disabled={!sourceRef} onClick={addSource} loading={addLoading} size='m' stretched>Добавить</Button>} value={sourceRef} onKeyPress={handleSourcePress} disabled={isInputDisabled} onChange={e => setSourceRef(e.target.value)} status="focused" header="Input" placeholder="Введите источник..." />
                            </Section>
                        </AppRoot>
                    </Swiper.Item>
                    <Swiper.Item className={(keywordsFade ? 'fadeSlide' : null)}>
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={keywordsOpt}
                            height={150}
                            width={150}
                        />
                        <div className="welcome_no">
                            <Text className="welcomeHeadline" normalize={true} weight="1">Ключевые слова</Text>
                        </div>
                        <Text style={{ textAlign: "center" }} className="welcomeDesc" normalize={true} weight="3">Для поиска только самого необходимого</Text>
                        <AppRoot platform='ios'>
                            <Section className='sectionChannelTimers sectionChannelSources sectionChannelTimersList' footer='Добавьте ключевые слова для фильтрации новостей по заголовкам, или оставьте список пустым, чтобы получать новости из всех источников. В Telegram-каналах и группах/пабликах VK сервис ищет по всему содержанию.'>
                                {keywords.map((keyword, index) => (
                                    <Cell key={index} after={<CancelIcon onClick={() => { setKeywords((prevKeywords) => prevKeywords.filter((item) => item !== keyword)); }} />}>{keyword}</Cell>
                                ))}
                                <Input after={<Button className="addSource" before={<AddIcon />} disabled={!keywordRef} onClick={handleAddKeyword} size='m' stretched>Добавить</Button>} value={keywordRef} onKeyPress={handleKeywordsPress} onChange={e => setKeywordRef(e.target.value)} status="focused" header="Input" placeholder="Введите ключевое слово..." />
                            </Section>
                        </AppRoot>
                    </Swiper.Item>
                    <Swiper.Item className={(negativeFade ? 'fadeSlide' : null)}>
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={stopOpt}
                            height={150}
                            width={150}
                        />
                        <div className="welcome_no">
                            <Text className="welcomeHeadline" normalize={true} weight="1">Стоп-слова</Text>
                        </div>
                        <Text style={{ textAlign: "center" }} className="welcomeDesc" normalize={true} weight="3">Для фильтрации найденного</Text>
                        <AppRoot platform='ios'>
                            <Section className='sectionChannelTimers sectionChannelSources sectionChannelTimersList' footer='Добавьте стоп-слова, чтобы исключить нежелательные новости по заголовкам. В Telegram-каналах и группах/пабликах VK стоп-слова применяются ко всему содержанию.'>
                                {negative.map((neg, index) => (
                                    <Cell key={index} after={<CancelIcon onClick={() => { setNegative((prevNegative) => prevNegative.filter((item) => item !== neg)); }} />}>{neg}</Cell>
                                ))}
                                <Input after={<Button className="addSource" before={<AddIcon />} disabled={!negativeRef} onClick={handleAddNegative} size='m' stretched>Добавить</Button>} value={negativeRef} onKeyPress={handleNegativePress} onChange={e => setNegativeRef(e.target.value)} status="focused" header="Input" placeholder="Введите стоп-слово.." />
                            </Section>
                        </AppRoot>
                    </Swiper.Item>
                    <Swiper.Item className={(intervalFade ? 'fadeSlide' : null)}>
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={intervalOpt}
                            height={150}
                            width={150}
                        />
                        <div className="welcome_no">
                            <Text className="welcomeHeadline" normalize={true} weight="1">Когда публиковать</Text>
                        </div>
                        <Text style={{ textAlign: "center" }} className="welcomeDesc" normalize={true} weight="3">Укажите во сколько и в какие дни сервис должен публиковать контент</Text>
                        <AppRoot platform='ios'>
                            <Picker
                                cancelText="Отменить"
                                confirmText="Добавить"
                                mouseWheel={true}
                                columns={basicColumns}
                                visible={timeVisible}
                                onClose={() => {
                                    setTimeVisible(false)
                                }}
                                onConfirm={v => {
                                    const adjustTimeWithShift = (shiftTimer) => {
                                        const updatedTimers = new Set([...timers, shiftTimer]);
                                        return Array.from(updatedTimers);
                                    };

                                    const shiftedTimer = (addTimer) => {
                                        const [hours, minutes] = addTimer.split(':').map(Number);
                                        const newHours = (hours - timezone + 24) % 24;

                                        const timerToDelete = `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`

                                        return timerToDelete;
                                    }

                                    const newTimer = v.join('');
                                    const shiftTimer = shiftedTimer(newTimer);
                                    const newTimers = adjustTimeWithShift(shiftTimer);
                                    setTimers(newTimers);
                                }}
                            />
                            <Section className='sectionChannelTimers' header="Часовой пояс">
                                <Select onChange={handleZoneChange} defaultValue={timezone} header="Select" placeholder="Часовой пояс" name="timezone">
                                    {timeZones.map((option) => (
                                        <option key={option.shift} value={option.shift}>
                                            {option.gmt}
                                        </option>
                                    ))}
                                </Select>
                            </Section>
                            <Section className='sectionChannelTimers sectionChannelTimersList' header='Таймеры' footer='Дни постинга можно настроить позже в Расписании'>
                                {timezoneTimers && timezoneTimers.length > 0 && (
                                    <List className="timersList">
                                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', padding: '0 10px' }}>
                                            {timezoneTimers.map((timer, index) => (
                                                <Chip key={index} after={<CancelIcon onClick={() => handleDeleteTimer(timer)} />}>
                                                    {timer}
                                                </Chip>
                                            ))}
                                        </div>
                                    </List>
                                )}
                                <ButtonCell onClick={() => { setTimeVisible(true) }} style={{ color: '#2688eb' }} before={<AddIcon />}>Добавить таймер</ButtonCell>
                            </Section>
                        </AppRoot>
                    </Swiper.Item>
                    <Swiper.Item>
                        <Lottie
                            isClickToPauseDisabled={true}
                            options={finishOpt}
                            height={150}
                            width={150}
                        />
                        <div className="welcome_no">
                            <Text className="welcomeHeadline" normalize={true} weight="1">Отлично! Вы настроили сервис и он готов публиковать контент в вашем канале</Text>
                        </div>
                        <Text style={{ textAlign: "center" }} className="welcomeDesc" normalize={true} weight="3">Активируйте, чтобы начать постинг прямо сейчас (посты будут выходить по расписанию)</Text>
                    </Swiper.Item>
                </Swiper>
                {/* <span>Группа: {selectedGroup.id}</span>
                <span>Источники: {sources.join(', ')}</span>
                <span>Ключевые слова: {keywords.join(', ')}</span>
                <span>Стоп-слова: {negative.join(', ')}</span>
                <span>Таймеры: {timers.join(', ')}</span>
                <span>Часовой пояс: {timezone}</span>
                <span>Index: {slideIndex}</span> */}
                <div className='OnboardingButtonContainer'>
                    <Button
                        disabled={disableNext}
                        stretched
                        style={{ marginTop: '30px', flexGrow: '0' }}
                        size='m'
                        onClick={handleMainButton}
                    >
                        {sources.length > 0 ? buttonName : 'Добавьте источники'}
                    </Button>
                    <Button stretched style={{ display: secondButton ? 'block' : 'none', marginTop: '10px', flexGrow: '0' }} mode="secondary" size='m' onClick={handleSecondButton}>{secondButtonText}</Button>
                </div>
                {/* <Button disabled={disableNext} style={{ marginTop: '10px' }} size='m' onClick={() => { handleSaveFeed() }}>Сохранить ленту</Button> */}
            </div>
        </div >
    );
};

export default ChannelPageTest;